import { ITemplate, IUserTemplateCategory } from "../models";

export const getTemplateCategory = (yaml: string): string | undefined => {
    const match = yaml.match(/name:\s*['"]?([^'"\n\r]*)['"]?/);

    if (!match) {
        return;
    }

    const yamlName = match[1].trim();
    return extractCategoryFromName(yamlName);
};

export const extractCategoryFromName = (name: string): string => {
    return name.split(" \\ ").slice(0, -1).join(" \\ ");
};

export const splitYamlName = (yaml: string): [string | null, string | null] => {
    const match = yaml.match(/(name: )(.*)/);
    const name = match ? match[2].split("\\").slice(-1)[0].trim() : null;
    const category = match ? match[2].split("\\").slice(0, -1).join("\\").trim() : null;
    return [category, name];
}

export const replaceYamlName = (yaml: string | undefined, name: string): string | undefined => {
    if (!yaml) return;
    return yaml.replace(/(name: )(.*)/, `name: ${name}`);
};

export const normalizeCategory = (category?: string): string | undefined => {
    if (!category) {
        return;
    }
    let trimmed = category.trim().replace(/^\\+|\\+$/g, "");
    return trimmed.replace(/\\+/g, " \\ ").replace(/\s+\\/g, " \\").replace(/\\\s+/g, "\\ ").trim();
};

export const getTemplateWithNewCategory = (template: ITemplate | undefined, userTemplateCategory: IUserTemplateCategory): ITemplate | undefined => {
    const category = normalizeCategory(userTemplateCategory.selectedCategory || userTemplateCategory.inputtedCategory);
    const [oldCategory, oldName] = template ? splitYamlName(template.yaml) : ["", ""];
    if ((oldCategory && !category) || (oldCategory && oldCategory === category)) return template;

    return {
        ...template,
        yaml: replaceYamlName(template?.yaml, `${category || "Пользовательские"} \\ ${oldName}`)
    } as ITemplate;
};
